import React from 'react';
import { useNavigate } from 'react-router-dom';
import Page from '../../../common/Page';
import MenuCard from '../../../common/MenuCard';
import { faCalendarDays, faClockRotateLeft, faCirclePlus, faBell } from '@fortawesome/free-solid-svg-icons';
import { useCurrentUser, isSuperAdmin } from '../../../common/UserContext';

// Voci del menù principale: per aggiungerne una basta un nuovo oggetto
const MENU = [
  { key: 'future', label: 'Eventi futuri', subtitle: 'Da oggi in avanti', path: '/admin/events/future', icon: faCalendarDays },
  { key: 'past', label: 'Eventi passati', subtitle: 'Fino a ieri', path: '/admin/events/past', superAdminOnly: true, icon: faClockRotateLeft },
  { key: 'create', label: 'Crea Evento', subtitle: 'Nuovo evento pubblico o privato', path: '/admin/events/new', superAdminOnly: true, icon: faCirclePlus },
  { key: 'withdrawal', label: 'Notifica Ritiro', subtitle: 'Avvisa i clienti che le ceramiche sono pronte', path: '/admin/withdrawal', superAdminOnly: true, icon: faBell },
];

function Home() {
  const navigate = useNavigate();
  const user = useCurrentUser();
  const items = MENU.filter((item) => !item.superAdminOnly || isSuperAdmin(user));

  return (
    <Page>
      {items.map((item) => (
        <MenuCard
          key={item.key}
          title={item.label}
          subtitle={item.subtitle}
          icon={item.icon}
          onClick={() => navigate(item.path)}
        />
      ))}
    </Page>
  );
}

export default Home;
